if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"shell","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(156|169|405|531|867)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}